// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__6mXpy","item":"PaymentsMobile_item__38A0V","label":"PaymentsMobile_label__10PAw","amount":"PaymentsMobile_amount__DIUiX"};